"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _get = _interopRequireDefault(require("lodash/get"));
var _universalCookie = _interopRequireDefault(require("universal-cookie"));
var _configuedStore = require("../configuedStore");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const cookies = new _universalCookie.default();
const translateTo = (word, lang, options = null, parentTranslations = null) => {
  const isOpenTransifex = cookies.get('transifex_sidebar');
  const store = (0, _configuedStore.configureStore)({});
  const translations = parentTranslations || (0, _get.default)(store.getState(), 'translations', {});
  let newString = word;
  if (Object.keys(translations).length > 0) {
    if (!isOpenTransifex) {
      if (translations) {
        const translationJSON = (0, _get.default)(translations, lang, null);
        if (translationJSON) {
          newString = translationJSON[word];
        }
      }
    }
  }
  if (options) {
    options.forEach((option, index) => {
      newString = newString?.replace(`{{${index}}}`, option);
    });
  }
  if (newString && typeof newString === 'string') return newString?.replace(/&amp;/g, '&') || word;
  return newString || word;
};
var _default = exports.default = translateTo;